// Contact details shown in the storefront chrome and homepage. Keep in sync
// with the footer and the About/Contact page content.
export const STORE = {
  name: 'BS Trading Co.',
  street: '253 Loy St',
  cityLine: 'Burleson, TX 76028',
  hours: 'Mon–Fri · 9am–5pm CT',
  phone: { label: '817-447-4433', href: 'tel:+18174474433' },
  tollFree: { label: '1-800-554-0910', href: 'tel:+18005540910' },
  email: { label: 'Orders@BSTrading.com', href: 'mailto:Orders@BSTrading.com' },
  faireUrl: 'https://bstradingco.faire.com?utm_source=embed',
};

export const mapsSearchUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const STORE_MAPS_URL = mapsSearchUrl(`${STORE.street}, ${STORE.cityLine}`);
